/* Navigate to the discovery builder with the selected scent and format. */
(() => {
 document.addEventListener('click', event => {
  const link = event.target.closest && event.target.closest('a[data-jw-pack-link]');
  if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const info = link.closest('product-info') || link.closest('.product__content') || link.closest('section');
  const input = info && info.querySelector('form[action*="/cart/add"] [name="id"]');
  const url = new URL(link.getAttribute('href'), window.location.href);
  // Use the product's assigned template: forcing a view can return Not Found.
  url.searchParams.delete('view');
  const variant = input && input.value || link.dataset.currentVariant;
  if (variant) url.searchParams.set('jw_variant', variant);
  // The Shopify preview cookie keeps this navigation in the current draft.
  // Preserve an explicit preview parameter, without guessing a theme ID.
  const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  link.href = url.href;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(url.href);
 }, true);
})();
